import type { BadgeProps } from '@/components/ui'

import type { AgentModeValue } from './types'

type BadgeVariant = NonNullable<BadgeProps['variant']>

type AgentModeLabelKey =
  'agents.modes.observeOnly.label' | 'agents.modes.suggest.label' | 'agents.modes.autoReply.label'

type AgentModeDescriptionKey =
  | 'agents.modes.observeOnly.description'
  | 'agents.modes.suggest.description'
  | 'agents.modes.autoReply.description'

interface AgentModeMeta {
  readonly labelKey: AgentModeLabelKey
  readonly descriptionKey: AgentModeDescriptionKey
  /** Cor do modo: neutro (so observa) -> info (sugere) -> warning (responde sozinho). Mesma escala do Desk. */
  readonly badgeVariant: BadgeVariant
}

const MODE_META: Record<AgentModeValue, AgentModeMeta> = {
  ObserveOnly: {
    labelKey: 'agents.modes.observeOnly.label',
    descriptionKey: 'agents.modes.observeOnly.description',
    badgeVariant: 'neutral',
  },
  Suggest: {
    labelKey: 'agents.modes.suggest.label',
    descriptionKey: 'agents.modes.suggest.description',
    badgeVariant: 'info',
  },
  AutoReply: {
    labelKey: 'agents.modes.autoReply.label',
    descriptionKey: 'agents.modes.autoReply.description',
    badgeVariant: 'warning',
  },
}

/** Rotulo/descricao/cor de produto de um modo conhecido (Observando/Sugerindo/Resposta automatica). */
export function agentModeMeta(mode: AgentModeValue): AgentModeMeta {
  return MODE_META[mode]
}

type AgentStatusLabelKey =
  'agents.statuses.Draft' | 'agents.statuses.Active' | 'agents.statuses.Disabled'

/**
 * Rotulo do status do agente (espelha `Codout.Support.Domain.Agents.AgentStatus`). `null` = status
 * desconhecido (valor futuro do backend): quem consome mostra o valor cru em vez de inventar rotulo.
 */
export function agentStatusLabelKey(status: string): AgentStatusLabelKey | null {
  switch (status) {
    case 'Draft':
      return 'agents.statuses.Draft'
    case 'Active':
      return 'agents.statuses.Active'
    case 'Disabled':
      return 'agents.statuses.Disabled'
    default:
      return null
  }
}

export function agentStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'Active':
      return 'success'
    case 'Disabled':
      return 'danger'
    default:
      return 'neutral'
  }
}
